import React, { useContext } from 'react'
import styles from './index.module.less'
import classnames from 'classnames'

import Item from './item'
import context from '../../../context'

export default function Seller() {
  const {
    superior: {
      seller: { cost, multiple, fast, safe, professional },
    },
    lang,
  } = useContext(context)
  return (
    <section className={styles.seller}>
      <span className={classnames(styles.caption, styles[lang])} />
      <Item module="cost" {...cost} />
      <Item module="multiple" {...multiple} />
      <Item module="fast" {...fast} />
      <Item module="safe" special {...safe} />
      <Item module="professional" special {...professional} />
    </section>
  )
}
